import * as React from "react";

/**
 * The id a `<Field>` minted for its control.
 *
 * Exists so a control that isn't a plain DOM element can pick the id up itself:
 * Radix's `Select` root renders no DOM, so `Field` can't hand it an id by
 * cloning — `SelectTrigger` reads this instead and puts it on the button it
 * renders, which is what the label can actually point at.
 *
 * Undefined outside a `Field`.
 */
export const FieldControlIdContext = React.createContext<string | undefined>(undefined);

export function useFieldControlId(): string | undefined {
  return React.useContext(FieldControlIdContext);
}
